/**
 * Safe logging — never prints tokens, passwords, or full API payloads in production.
 */

const isDev = import.meta.env.DEV

function sanitizeError(error: unknown): string | undefined {
  if (error == null) return undefined
  if (typeof error === 'string') return error
  if (error instanceof Error) return error.message

  const e = error as {
    message?: string
    error?: string
    status?: string | number
    data?: { message?: unknown }
  }

  if (e.data?.message != null) {
    const msg = e.data.message
    if (typeof msg === 'string') return msg
    if (Array.isArray(msg)) return msg.filter(m => typeof m === 'string').join('. ')
  }
  if (typeof e.error === 'string') return e.error
  if (typeof e.message === 'string') return e.message
  if (e.status != null) return `Request failed (${String(e.status)})`

  return undefined
}

/** Log errors without leaking auth headers or response bodies in production */
export function logError(context: string, error?: unknown): void {
  const detail = sanitizeError(error)
  if (isDev && detail) {
    console.error(context, detail)
  } else {
    console.error(context)
  }
}

/** Dev-only debug logging (stripped from production builds) */
export function logDebug(...args: unknown[]): void {
  if (isDev) {
    console.debug(...args)
  }
}
